// src/config.js
const applicationMode = "live";
var appName = "KOH Member Panel";

//local
/*
var apiUrl = "http://localhost/tkp-club/";
var logo = "http://localhost/tkp-club/uploads/logo/logo.png";
var imageBasePath = "http://localhost/tkp-club/uploads";
var sponsorUrl = "https://memberkoh.tkpdemo03.online/members/register/sponsor/";
*/

//server
var apiUrl = "https://api.kohpicnic.com/";
var logo = "https://api.kohpicnic.com/uploads/logo/logo.png";
var imageBasePath = "https://api.kohpicnic.com/uploads";
var sponsorUrl = "https://member.kohpicnic.com/members/register/sponsor/";


var pageSize = 10;

if (applicationMode === 'development') {
  appName = "KOH Member Panel";
  
  //local
  //apiUrl = "http://localhost/tkp-club/";

  //server
  apiUrl = "https://api.kohpicnic.com/";
}
const config = {
  appName: appName,
  apiUrl: apiUrl,
  pageSize: pageSize,
  logo: logo,
  imageBasePath: imageBasePath,
  sponsorUrl: sponsorUrl
};
export default config;